import { createContext, useContext, type ReactNode } from "react";
import type { SsrBlogPost } from "@shared/blogSsr";

const SsrBlogContext = createContext<SsrBlogPost | null | undefined>(undefined);

export function SsrBlogProvider({
  post,
  children,
}: {
  post?: SsrBlogPost | null;
  children: ReactNode;
}) {
  return <SsrBlogContext.Provider value={post}>{children}</SsrBlogContext.Provider>;
}

/** undefined = client-only navigation; null = SSR miss; object = SSR prefetched post */
export function useSsrBlogPost(): SsrBlogPost | null | undefined {
  return useContext(SsrBlogContext);
}
